import React from 'react';
import PropTypes from 'prop-types';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TicketPageError = ({ title, message }) => (
  <Box
    data-testid="ticket-page-error"
    role="alert"
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1.5,
      px: 3,
      textAlign: 'center'
    }}
  >
    <ErrorOutlineIcon color="error" sx={{ fontSize: 48 }} aria-hidden />
    {title && (
      <Typography variant="h5" component="h1">
        {title}
      </Typography>
    )}
    <Typography variant={title ? 'body1' : 'h5'} component={title ? 'p' : 'h1'} color="text.secondary">
      {message}
    </Typography>
  </Box>
);

TicketPageError.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired
};

export default TicketPageError;
